import { EMBEDDED_SESSION_ID, MAIN_SESSION_ID } from "../../../reducers/session/sessionVariables";
import storage from "../../../utils/store/storage";

export const COMFLOW = "COMFLOW";

export const isRedirectToComflowAllowed = (): boolean => {
  const allow = process.env.REACT_APP_ALLOW_REDIRECT_TO_COMFLOW === "TRUE";

  return allow;
};

export async function redirectToComflow(): Promise<void> {
  // Need to manually delete MAIN_SESSION_ID and EMBEDDED_SESSION_ID from storage to
  // avoid login loop if returned from Comflow
  // Cannot use logout, since we will lose the session before(?) redirecting
  // Next time user returns login screen will be shown
  await storage.deleteItem(MAIN_SESSION_ID);
  await storage.deleteItem(EMBEDDED_SESSION_ID);

  window.open(process.env.REACT_APP_COMFLOW_WEBAPP, "_self");
}
